import { sealed } from '@/decorators'
import type { Point } from '@/types'

import type { UserActionState, ZOOM_LEVELS } from './constants'

@sealed
export class GridCoords {
  readonly id: number
  readonly x: number
  readonly y: number

  constructor(x: number, y: number, gridColsLength: number) {
    this.id = y * gridColsLength + x
    this.x = x
    this.y = y
  }

  [Symbol.toPrimitive]() {
    return this.id
  }
}

@sealed
export class ScreenPosition {
  readonly x: number
  readonly y: number

  constructor(x: number, y: number) {
    this.x = x
    this.y = y
  }
}

export type UserAction = Readonly<
  | {
      state: UserActionState.Idle
    }
  | {
      state: UserActionState.Panning
      minDelta: Point
      screenStart: ScreenPosition
    }
  | {
      state: UserActionState.Selecting
    }
>

export type ZoomRatio = (typeof ZOOM_LEVELS)[number]
